export interface Player {
  id: number;
  number: string;
  name: string;
  position: string;
  positionGroup: 'Offense' | 'Defense' | 'Special Teams';
  height: string;
  weight: string;
  college: string;
  experience: string;
  hometown: string;
  image: string;
  bio: string;
}

export interface Coach {
  id: number;
  name: string;
  title: string;
  experience: string;
  college: string;
  image: string;
  bio: string;
}

export const players: Player[] = [
  // Offense
  {
    id: 1,
    number: '9',
    name: 'J.J. McCarthy',
    position: 'QB',
    positionGroup: 'Offense',
    height: '6\'2"',
    weight: '218 lbs',
    college: 'Michigan',
    experience: '2nd Year',
    hometown: 'Swarthmore, PA',
    image: 'https://public.readdy.ai/ai/img_res/8de830d3c81da5346e4826dfcb6c96ef.jpg',
    bio: 'The future of the Vikings franchise, McCarthy brings elite arm talent and championship pedigree from his national title run at Michigan.',
  },
  {
    id: 2,
    number: '33',
    name: 'Aaron Jones',
    position: 'RB',
    positionGroup: 'Offense',
    height: '5\'9"',
    weight: '208 lbs',
    college: 'UTEP',
    experience: '8th Year',
    hometown: 'Savannah, GA',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20running%20back%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20dynamic%20running%20pose%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player2&orientation=portrait',
    bio: 'A proven veteran with elite pass-catching ability out of the backfield. Jones brings championship experience and leadership to the Vikings offense.',
  },
  {
    id: 3,
    number: '18',
    name: 'Justin Jefferson',
    position: 'WR',
    positionGroup: 'Offense',
    height: '6\'1"',
    weight: '195 lbs',
    college: 'LSU',
    experience: '5th Year',
    hometown: 'St. Rose, LA',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20wide%20receiver%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20catching%20pose%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player3&orientation=portrait',
    bio: 'One of the most electrifying receivers in NFL history. Jefferson holds the record for most receiving yards in a player\'s first four seasons.',
  },
  {
    id: 4,
    number: '17',
    name: 'Jordan Addison',
    position: 'WR',
    positionGroup: 'Offense',
    height: '5\'11"',
    weight: '173 lbs',
    college: 'USC',
    experience: '3rd Year',
    hometown: 'Potomac, MD',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20wide%20receiver%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20speed%20route%20running%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player4&orientation=portrait',
    bio: 'A dynamic route runner with elite speed and separation ability. Addison has emerged as one of the most dangerous slot receivers in the NFC.',
  },
  {
    id: 5,
    number: '85',
    name: 'T.J. Hockenson',
    position: 'TE',
    positionGroup: 'Offense',
    height: '6\'4"',
    weight: '248 lbs',
    college: 'Iowa',
    experience: '7th Year',
    hometown: 'Sioux City, IA',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20tight%20end%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20blocking%20catching%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player5&orientation=portrait',
    bio: 'A complete tight end who excels as both a blocker and receiver. Hockenson is one of the premier pass-catching tight ends in the entire NFL.',
  },
  {
    id: 6,
    number: '71',
    name: 'Christian Darrisaw',
    position: 'LT',
    positionGroup: 'Offense',
    height: '6\'5"',
    weight: '322 lbs',
    college: 'Virginia Tech',
    experience: '5th Year',
    hometown: 'Upper Marlboro, MD',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20offensive%20lineman%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20powerful%20stance%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player6&orientation=portrait',
    bio: 'A dominant left tackle who anchors the Vikings offensive line. Darrisaw is widely regarded as one of the best pass protectors in the league.',
  },
  // Defense
  {
    id: 7,
    number: '55',
    name: 'Danielle Hunter',
    position: 'DE',
    positionGroup: 'Defense',
    height: '6\'5"',
    weight: '252 lbs',
    college: 'LSU',
    experience: '10th Year',
    hometown: 'Miramar, FL',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20defensive%20end%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20fierce%20pass%20rush%20pose%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player7&orientation=portrait',
    bio: 'A perennial Pro Bowler and one of the most feared pass rushers in the NFL. Hunter\'s combination of speed and power makes him virtually unblockable.',
  },
  {
    id: 8,
    number: '98',
    name: 'Jonathan Allen',
    position: 'DT',
    positionGroup: 'Defense',
    height: '6\'3"',
    weight: '300 lbs',
    college: 'Alabama',
    experience: '8th Year',
    hometown: 'Leesburg, VA',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20defensive%20tackle%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20powerful%20stance%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player8&orientation=portrait',
    bio: 'A dominant interior force who disrupts opposing offenses from the inside. Allen brings championship-level intensity and leadership to the Vikings defense.',
  },
  {
    id: 9,
    number: '54',
    name: 'Eric Kendricks',
    position: 'LB',
    positionGroup: 'Defense',
    height: '6\'0"',
    weight: '232 lbs',
    college: 'UCLA',
    experience: '10th Year',
    hometown: 'Fresno, CA',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20linebacker%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20ready%20stance%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player9&orientation=portrait',
    bio: 'A cerebral linebacker who reads offenses like a quarterback. Kendricks is the defensive captain and the heartbeat of the Vikings defense.',
  },
  {
    id: 10,
    number: '29',
    name: 'Shaquill Griffin',
    position: 'CB',
    positionGroup: 'Defense',
    height: '6\'0"',
    weight: '196 lbs',
    college: 'UCF',
    experience: '8th Year',
    hometown: 'St. Petersburg, FL',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20cornerback%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20coverage%20stance%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player10&orientation=portrait',
    bio: 'A physical cornerback who thrives in press coverage. Griffin brings veteran leadership and shutdown ability to the Vikings secondary.',
  },
  {
    id: 11,
    number: '21',
    name: 'Camryn Bynum',
    position: 'S',
    positionGroup: 'Defense',
    height: '6\'0"',
    weight: '200 lbs',
    college: 'California',
    experience: '4th Year',
    hometown: 'Honolulu, HI',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20safety%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20athletic%20interception%20pose%20portrait%20studio%20white%20background&width=400&height=500&seq=player11&orientation=portrait',
    bio: 'A rising star in the Vikings secondary who has developed into one of the most versatile safeties in the NFC. Bynum leads the team in tackles.',
  },
  {
    id: 12,
    number: '22',
    name: 'Harrison Smith',
    position: 'S',
    positionGroup: 'Defense',
    height: '6\'2"',
    weight: '214 lbs',
    college: 'Notre Dame',
    experience: '13th Year',
    hometown: 'Knoxville, TN',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20veteran%20safety%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20experienced%20leader%20pose%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player12&orientation=portrait',
    bio: 'A Vikings legend and future Hall of Famer. Smith is the ultimate team leader whose football IQ and versatility are unmatched in the entire league.',
  },
  // Special Teams
  {
    id: 13,
    number: '7',
    name: 'Greg Joseph',
    position: 'K',
    positionGroup: 'Special Teams',
    height: '6\'0"',
    weight: '195 lbs',
    college: 'Florida Atlantic',
    experience: '6th Year',
    hometown: 'Plantation, FL',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20kicker%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20kicking%20pose%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player13&orientation=portrait',
    bio: 'A reliable kicker with a strong leg capable of making field goals from 55+ yards. Joseph has been clutch in high-pressure situations throughout his career.',
  },
  {
    id: 14,
    number: '5',
    name: 'Ryan Wright',
    position: 'P',
    positionGroup: 'Special Teams',
    height: '6\'4"',
    weight: '230 lbs',
    college: 'Tulane',
    experience: '4th Year',
    hometown: 'Baton Rouge, LA',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20punter%20player%20in%20purple%20and%20gold%20Minnesota%20Vikings%20uniform%20punting%20pose%20athletic%20portrait%20studio%20white%20background&width=400&height=500&seq=player14&orientation=portrait',
    bio: 'One of the best punters in the NFL with exceptional hang time and directional kicking ability. Wright consistently pins opponents deep in their own territory.',
  },
];

export const coaches: Coach[] = [
  {
    id: 1,
    name: 'Kevin O\'Connell',
    title: 'Head Coach',
    experience: '4th Season',
    college: 'San Diego State',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20head%20coach%20in%20Minnesota%20Vikings%20purple%20polo%20shirt%20confident%20leadership%20pose%20sideline%20portrait%20studio%20clean%20background&width=400&height=480&seq=coach1&orientation=portrait',
    bio: 'A dynamic offensive mind who transformed the Vikings into one of the most explosive offenses in the NFL. O\'Connell brings an innovative approach and player-first culture to Minnesota.',
  },
  {
    id: 2,
    name: 'Brian Flores',
    title: 'Defensive Coordinator',
    experience: '3rd Season',
    college: 'Boston College',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20defensive%20coordinator%20coach%20in%20Minnesota%20Vikings%20purple%20polo%20shirt%20intense%20focused%20pose%20portrait%20studio%20clean%20background&width=400&height=480&seq=coach2&orientation=portrait',
    bio: 'A defensive mastermind known for his aggressive schemes and ability to develop young talent. Flores has built one of the most feared defenses in the NFC under his watch.',
  },
  {
    id: 3,
    name: 'Wes Phillips',
    title: 'Offensive Coordinator',
    experience: '4th Season',
    college: 'Tulsa',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20offensive%20coordinator%20coach%20in%20Minnesota%20Vikings%20purple%20polo%20shirt%20strategic%20planning%20pose%20portrait%20studio%20clean%20background&width=400&height=480&seq=coach3&orientation=portrait',
    bio: 'A creative play-caller who maximizes the talents of every offensive weapon. Phillips has developed a reputation for designing innovative schemes that keep defenses guessing.',
  },
  {
    id: 4,
    name: 'Matt Daniels',
    title: 'Special Teams Coordinator',
    experience: '2nd Season',
    college: 'Duke',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20special%20teams%20coordinator%20coach%20in%20Minnesota%20Vikings%20purple%20polo%20shirt%20energetic%20pose%20portrait%20studio%20clean%20background&width=400&height=480&seq=coach4&orientation=portrait',
    bio: 'An energetic and detail-oriented coach who has revitalized the Vikings special teams unit. Daniels brings a competitive edge and meticulous preparation to every phase of the game.',
  },
  {
    id: 5,
    name: 'Andrew Janocko',
    title: 'Wide Receivers Coach',
    experience: '4th Season',
    college: 'Pittsburgh',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20wide%20receivers%20coach%20in%20Minnesota%20Vikings%20purple%20polo%20shirt%20coaching%20pose%20portrait%20studio%20clean%20background&width=400&height=480&seq=coach5&orientation=portrait',
    bio: 'A former college receiver who has developed an elite connection with Justin Jefferson and Jordan Addison. Janocko\'s technical coaching has helped the Vikings WR corps become the best in the NFL.',
  },
  {
    id: 6,
    name: 'Curtis Modkins',
    title: 'Running Backs Coach',
    experience: '2nd Season',
    college: 'TCU',
    image: 'https://readdy.ai/api/search-image?query=professional%20American%20football%20running%20backs%20coach%20in%20Minnesota%20Vikings%20purple%20polo%20shirt%20motivational%20pose%20portrait%20studio%20clean%20background&width=400&height=480&seq=coach6&orientation=portrait',
    bio: 'A veteran coach with decades of experience developing elite running backs. Modkins brings a comprehensive approach to the position that emphasizes both rushing and receiving skills.',
  },
];

export const positionGroups = ['All', 'Offense', 'Defense', 'Special Teams'] as const;
export type PositionGroupFilter = typeof positionGroups[number];
